import React from 'react'

import compose from 'vegas-js-core/src/functors/compose'

import initApp from '../../../contexts/app/initApp'

import { withRouter } from 'react-router-dom'
import { withStyles } from '@material-ui/core/styles'

import CalendarIcon from '@material-ui/icons/CalendarViewDay'

import PropertyValue from '../../../things/PropertyValue'
import Event         from '../../../things/Event'

import ThingChildren, { styles } from '../ThingChildren'

class SubEvent extends ThingChildren
{
    getLocale = () => this.props.locale.things.event.subEvent ;
}

SubEvent.defaultProps =
{
    ...ThingChildren.defaultProps ,
    clazz      : Event,
    emptyClazz : PropertyValue,
    emptyIcon  : null ,
    icon       : <CalendarIcon/> ,
    member     : 'subEvent'
};

SubEvent.propTypes =
{
    ...ThingChildren.propTypes
};

export default compose( withStyles( styles ) , withRouter , initApp )( SubEvent ) ;